<template>
  <v-dialog
      ref="dialog"
      v-model="open"
      persistent
      width="800px"
  >

    <v-card>
      <v-container>
        <v-row>
          <v-col class="mt-6" style="max-height: 540px;overflow: scroll">
            <v-select
                class="mb-2"
                v-model="selected_province"
                label="จังหวัด"
                :items="provinces"
                multiple
                hide-details
                outlined
                small
                @change="onSelectProvince()"
            >
            </v-select>
            <v-card v-for="order in orders.filter(order=>{
              if(selected_province.length==0)return true
              const province = (order.shipping_address && order.shipping_address.district && order.shipping_address.district.city && order.shipping_address.district.city.province ? order.shipping_address.district.city.province.name :
                          (
                              (order.customer && order.customer.province_obj) ? order.customer.province_obj.name
                                  : (order.customer ? order.customer.province : '???')
                          )
                  )

              return selected_province.includes(province)
            })" class="clickable pa-2 mb-2"
                    :disabled="isDuplicate(order)"
                    @click="clickOrder(order)"
            >
              <v-btn class="float-right" style="height:auto" small :color="getStatusColor(order.status)" tile>{{
                  map(order.status)
                }}
                <br v-if="order.destination && order.destination.route && order.destination.route.truck "/>
                {{
                  order.destination && order.destination.route && order.destination.route.truck && (`${order.destination.route.truck.plate}(${routeStatus(order.destination.route.status)})`)
                }}
              </v-btn>

              <small v-if="isDuplicate(order)" class="caption">
            <span class="green pl-1 pr-1 mr-1 float-left" style="color: white;word-break: keep-all"
            >เลือกแล้ว</span>
              </small>


              {{ $helper.date_format_short(order.date_delivery) }} <span class="body-2">{{ order.code }} </span>
              <br/>
              <span class="body-2">
                  {{ (order.customer ? order.customer.nickname : null) || order.customer_code }}
                <br/>
                  {{
                  (order.shipping_address && order.shipping_address.district && order.shipping_address.district.city && order.shipping_address.district.city.province ? order.shipping_address.district.city.province.name :
                          (
                              (order.customer && order.customer.province_obj) ? order.customer.province_obj.name
                                  : (order.customer ? order.customer.province : '???')
                          )
                  )
                }}

                ({{ $helper.number_format(order.total_net, 2, 2) }})</span>


              <small v-if="!order.customer || !order.customer.gis_is_confirm" class="caption">
            <span class="ml-1 red pa-1 float-right" style="color: white;word-break: keep-all"
            >ที่อยู่ยังไม่ยืนยัน</span>
              </small>


              <div class="comment">
                {{ order.comment }}
              </div>


            </v-card>

          </v-col>
          <v-col>
            <form @submit.prevent="clickApply">
              <v-container>
                <v-row>
                  <v-col>
                    <v-text-field
                        v-model="keyword"
                        :append-icon="loading ? 'mdi-loading':'mdi-magnify'"
                        :loading="loading"
                        clearable
                        hide-details
                        label="หมายเลข SO"
                        outlined
                        placeholder="หมายเลข SO เช่น SOTT-210100001"
                        required
                        @keypress.enter.prevent="onClickSearch()"
                        @click:append="onClickSearch()"
                    ></v-text-field>
                  </v-col>

                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field

                        v-model="lat"
                        class="dialog-input"
                        hide-details
                        label="latitude"
                        outlined
                        placeholder=""
                        required
                        step="0.0000000000000001"
                        type="number"
                    >
                    </v-text-field>

                  </v-col>
                  <v-col>
                    <v-text-field

                        v-model="lng"
                        class="dialog-input"
                        hide-details
                        label="longitude"
                        outlined
                        placeholder=""
                        required
                        step="0.0000000000000001"
                        type="number"
                    >
                    </v-text-field>
                  </v-col>

                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field

                        v-model="volume"
                        class="dialog-input"
                        hide-details
                        label="ปริมาตร"
                        outlined
                        placeholder=""
                        required
                        step="0.001"
                        suffix="cbm"
                        type="number"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field

                        v-model="weight"
                        class="dialog-input"
                        hide-details
                        label="น้ำหนัก"
                        outlined
                        placeholder=""
                        required
                        step="0.01"
                        suffix="kg"
                        type="number"
                    >
                    </v-text-field>

                  </v-col>


                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field

                        v-model="worth"
                        class="dialog-input"
                        hide-details
                        label="มูลค่า"
                        outlined
                        placeholder=""
                        required
                        step="0.01"
                        suffix="บาท"
                        type="number"
                    >
                    </v-text-field>

                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-autocomplete
                        v-model="district_id"
                        :items="districtItems"
                        :loading="isLoadingDistricts"
                        :search-input.sync="search"
                        auto-select-first
                        class="login-input"
                        hide-details
                        hide-no-data

                        item-text="name"
                        item-value="id"
                        label="ตำบล"
                        outlined
                        placeholder="ค้นหา"
                        required
                        return-object
                        @change="changeDistrict"
                    >
                      <template v-slot:item="data">
                        {{ data.item.Description }}
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field

                        v-model="city_name"
                        class="login-input"
                        disabled
                        hide-details
                        label="อำเภอ"
                        outlined
                        placeholder=""
                        readonly

                    >
                    </v-text-field>


                  </v-col>
                  <v-col>


                    <v-text-field

                        v-model="province_name"
                        class="login-input"
                        disabled
                        hide-details
                        label="จังหวัด"
                        outlined
                        placeholder=""
                        readonly

                    >
                    </v-text-field>

                  </v-col>
                </v-row>


              </v-container>
              <v-card-actions>
                <v-checkbox
                    v-model="non_average"
                    label="ไม่ถัวค่าส่ง"
                    hide-details
                ></v-checkbox>
                {{ message }}

                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="open = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                    color="primary"

                    type="submit"
                >
                  OK
                </v-btn>
              </v-card-actions>
            </form>
          </v-col>
        </v-row>
      </v-container>
    </v-card>


  </v-dialog>
</template>

<style lang="scss" scoped>
.comment {
  font-size: 0.8rem !important;
  font-weight: normal;
  line-height: 1rem;
  color: dimgray;
}
</style>
<script lang="ts">

import {DataDestination} from '@/models/Destination'
import {DataArray} from '@/models/Response'
import {RouteConst} from '@/models/Route'
import Helper from '@/services/Helper'
import moment from 'moment-timezone'
import {Component, Vue, Watch} from 'vue-property-decorator'
import {Order, OrderConst} from '@/models/Order'


@Component({
  components: {}
})
export default class OrderPicker extends Vue {

  open: boolean = false

  loading = false
  keyword = ''
  weight: number | null = null
  volume: number | null = null
  worth: number | null = null
  lat = ''
  lng = ''
  district_id = ''
  message = ''
  entries = [{
    id: '00000',
    name: '',
    'province_id': 0,
    city: {
      name: '',
      province: {
        name: ''
      }
    }
  }]
  // countDistricts = 0
  isLoadingDistricts = false
  search = ''
  district_name = ''
  city_name = ''
  province_name = ''
  non_average = false

  get districtItems() {
    return this.entries.map(entry => {
      let district = entry.name

      if (!entry.hasOwnProperty('city')) {
        return Object.assign({}, entry, {
          id: '00000',
          name: district,
          city: '',
          province: '',
          Description: district
        })
      }

      let city = entry.city.name
      let province = entry.city.province.name
      if (entry.province_id == 10) {
        district = 'แขวง' + district
        // city =  city
        province = '' + province
      } else {
        district = 'ต.' + district
        // city = 'อ.' + city
        // province = 'จ.' + province
      }
      const Description = entry.name + ' > ' + entry.city.name + ' > ' + entry.city.province.name
      return Object.assign({}, entry, {
        id: entry.id,
        name: district,
        city: city,
        province: province,
        Description
      })
    })
  }

  onApply: Function = () => {


  }

  created() {
    this.$root.$on('openOrderPicker', this.onOpen)
  }

  orders: Order[] = []

  existingCode: string[] = []

  provinces: any = []

  onOpen({onApply, existingCode}) {
    if (this.open) return

    this.existingCode = existingCode

    // console.log(existingCode)

    this.open = true

    this.orders = []
    this.refreshOrder()


    this.onApply = onApply
  }

  isLoadOrders = false

  async refreshOrder() {
    const url = `${Helper.setting.order.getListAPI}?with_destination=true&sort=date_delivery&sortDesc=0&doc_book=SOPJ,SOHM,SOTT&status=300,400,500,600,700,800&page_size=500&from_date=${moment().add(-90, 'days').format('YYYY-MM-DD')}`

    try {
      this.isLoadOrders = true
      this.orders = await Helper.get(url).then<{ data: DataArray }>(({data}) => data.data)


      var province_count = {}
      for (const i in this.orders) {
        const order = this.orders[i]
        const province =
            (order.shipping_address && order.shipping_address.district && order.shipping_address.district.city && order.shipping_address.district.city.province ? order.shipping_address.district.city.province.name :
                    (
                        (order.customer && order.customer.province_obj) ? order.customer.province_obj.name
                            : (order.customer ? order.customer.province : '???')
                    )
            )
        if (province) {
          if (province_count[province]) {
            province_count[province]++
          } else {
            province_count[province] = 1
          }
        }
      }

      this.provinces = []
      for (const name in province_count) {
        this.provinces.push({text: name + '(' + province_count[name] + ')', value: name})
      }

    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.isLoadOrders = false
  }

  clickApply() {
    const action = {
      'code': this.keyword,
      'lat': this.lat,
      'lng': this.lng,
      'weight': this.weight,
      'volume': this.volume,
      'worth': this.worth,
      'district_id': this.district_id,
      'district': {
        name: this.district_name,
        city: {
          name: this.city_name
        },
        province: {
          name: this.province_name
        }
      },
      'non_average': this.non_average
    }
    this.onApply && this.onApply(action)

    this.open = false
  }

  onClickSearch() {
    const id = this.keyword
    this.loading = true
    Helper.get(Helper.setting.destination.getResourceAPI.replace('{id}', id))
        .then<{ data: DataDestination }>(({data}) => {

          console.log('getOrder', data.data)

          this.weight = Math.round(data.data.load_weight_kg * 100) / 100
          this.volume = Math.round(data.data.load_volume_cbm * 100) / 100
          this.worth = Math.round(data.data.worth_amount * 100) / 100

          this.lat = data.data.lat
          this.lng = data.data.lng
          this.district_id = data.data.ref_district_id


          if (data.data.district) {

            this.entries = [{
              id: this.district_id,
              name: data.data.district.name,
              'province_id': 0,
              city: {
                name: data.data.district.city.name,
                province: {
                  name: data.data.district.city.province.name
                }
              }
            }]

            this.district_name = data.data.district.name
            this.city_name = data.data.district.city.name
            this.province_name = data.data.district.city.province.name
          }
          this.loading = false
        }).catch(error => {
      if (error && error.response && error.response.status == 404) {
        this.$root.$emit('onError', {message: 'ไม่พบออร์เดอร์', error: error})
        this.loading = false
      } else {
        this.$root.$emit('onError', {error: error})
        this.loading = false
      }
    })
  }

  selected_province = []

  onSelectProvince() {
  }


  clickOrder(order: Order) {
    if (order.code)
      this.keyword = order.code
    this.onClickSearch()
  }

  changeDistrict(val: any) {
    console.log(val)
    if (val && val.id)
      this.district_id = val.id
    if (val && val.city) {
      this.city_name = val.city
    }
    if (val && val.province) {
      this.province_name = val.province
    }
  }


  @Watch('search')
  async onSearchChanged(val: string, oldValue: string) {
    // Items have already been loaded
    //
    if (val === null) return
    if (this.districtItems.length > 0) {
      const found = this.districtItems.filter(obj => val == obj.name)
      if (found.length >= 1) {
        return
      }
    }


    // // Items have already been requested
    // if (this.isLoadingDistricts) return
    console.log([oldValue, val])

    if (val && val.length < 3) return

    this.isLoadingDistricts = true

    // Lazily load input items
    const url = Helper.setting.district.getListAPI + '?keyword=' + val
    try {
      const data: any = await Helper.get(url).then<{ data: any }>(({data}) => data)
      // this.countDistricts = data.count
      this.entries = data.districts
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.isLoadingDistricts = false
  }

  map(status) {
    return OrderConst.map(status)
  }

  routeStatus(status) {
    return RouteConst.map(status)
  }

  getStatusColor(status) {
    return OrderConst.color(status)
  }

  isDuplicate(order) {
    return this.existingCode.includes(order.code)
  }
};

</script>
